import React, { createContext, useContext } from 'react';
import useConfirmDeletePositions from './useConfirmDeletePositions';
import { IFinalFormFieldArrayInputComponentProps } from '@/Framework/UI/Organisms/FinalForm/interfaces';

type ConfirmDeletePositionContextType = ReturnType<typeof useConfirmDeletePositions>;
export const ConfirmDeletePositionContext = createContext<ConfirmDeletePositionContextType>(null);

export const useConfirmDeletePositionContext = () => {
  const context = useContext(ConfirmDeletePositionContext);
  if (!context) {
    throw new Error('useConfirmDeletePositionContext must be used within the ConfirmDeletePositionContext');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
  fields: IFinalFormFieldArrayInputComponentProps['fields'],
}

const ConfirmDeletePositionContextProvider = ({ children, fields }: IProps) => (
  <ConfirmDeletePositionContext.Provider value={ useConfirmDeletePositions(fields) }>
    { children }
  </ConfirmDeletePositionContext.Provider>
);

export default ConfirmDeletePositionContextProvider;
